import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import Banner from '../Component/BlogTriple/Banner'
import BlogDetailSection from '../Component/BlogTriple/BlogDetailSection'

function BlogTriple() {
  return (
    <div>
        <NavBar/>
        <Banner/>
        <BlogDetailSection/>
        <Footer/>
    </div>
  )
}

export default BlogTriple